(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[350],{

/***/ 81453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79077);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var ItemCard = function(param) {
    var Label = param.label, children = param.children, _isFullHeight = param.isFullHeight, isFullHeight = _isFullHeight === void 0 ? false : _isFullHeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().itemColumn),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "itemCardLabelTop ".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().itemTop)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "itemCardBottom ".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().itemBottom), " ").concat(isFullHeight ? (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().isFullHeight) : ""),
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ItemCard));


/***/ }),

/***/ 80423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ draw_cards; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(25155);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/ui/button/index.jsx
var ui_button = __webpack_require__(61257);
// EXTERNAL MODULE: ./src/components/entity/draw/cards/info-cards/index.jsx
var info_cards = __webpack_require__(96223);
// EXTERNAL MODULE: ./src/components/ui/popover/with-link/styles.module.css
var styles_module = __webpack_require__(6051);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/ui/popover/styles.module.css
var popover_styles_module = __webpack_require__(77470);
var popover_styles_module_default = /*#__PURE__*/__webpack_require__.n(popover_styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ui/icons/index.jsx + 150 modules
var icons = __webpack_require__(20068);
;// CONCATENATED MODULE: ./src/components/ui/popover/index.jsx




var Popover = function(param) {
    var info = param.info;
    var ref = (0,react.useState)(false), isOpened = ref[0], setIsOpened = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (popover_styles_module_default()).popoverContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (popover_styles_module_default()).iconContainer,
                onMouseEnter: function() {
                    return setIsOpened(true);
                },
                onMouseLeave: function() {
                    return setIsOpened(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PopoverIcon */.f8, {})
            }),
            isOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (popover_styles_module_default()).popoverPopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (popover_styles_module_default()).popoverText,
                    children: info
                })
            })
        ]
    });
};
/* harmony default export */ var popover = (/*#__PURE__*/(0,react.memo)(Popover));

;// CONCATENATED MODULE: ./src/components/ui/popover/with-link/index.jsx



var PopoverWithLink = function(param) {
    var info = param.info, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).popoverRow,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover, {
                info: info
            })
        ]
    });
};
/* harmony default export */ var with_link = (PopoverWithLink);

// EXTERNAL MODULE: ./src/components/entity/draw/cards/info-cards/with-button/styles.module.css
var with_button_styles_module = __webpack_require__(54587);
var with_button_styles_module_default = /*#__PURE__*/__webpack_require__.n(with_button_styles_module);
;// CONCATENATED MODULE: ./src/components/entity/draw/cards/info-cards/with-button/index.jsx








var InfoCardWithButton = function(_param) {
    var _card = _param.card, btn = _card.btn, link = _card.link, prop = (0,_object_without_properties/* default */.Z)(_param.card, [
        "btn",
        "link"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (with_button_styles_module_default()).cardWithBtnColumn,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(info_cards/* default */.Z, {
                card: prop
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: btn.link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    rel: "nofollow",
                    className: (with_button_styles_module_default()).buttonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.ZP, {
                        type: ui_button/* BUTTON_TYPES.BLUE */.Dx.BLUE,
                        text: btn.text
                    })
                })
            }),
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: link.info ? /*#__PURE__*/ (0,jsx_runtime.jsx)(with_link, {
                    info: link.info,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: link.href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            rel: "nofollow",
                            className: (with_button_styles_module_default()).linkText,
                            children: link.text
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: link.href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        rel: "nofollow",
                        className: (with_button_styles_module_default()).linkText,
                        children: link.text
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var with_button = (/*#__PURE__*/(0,react.memo)(InfoCardWithButton));

// EXTERNAL MODULE: ./src/components/entity/draw/cards/draw-cards/styles.module.css
var draw_cards_styles_module = __webpack_require__(92744);
var draw_cards_styles_module_default = /*#__PURE__*/__webpack_require__.n(draw_cards_styles_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/lib/constants/router.js
var router = __webpack_require__(32763);
// EXTERNAL MODULE: ./src/lib/constants/definition.js
var definition = __webpack_require__(13412);
// EXTERNAL MODULE: ./src/lib/utils/locus.js
var locus = __webpack_require__(30616);
;// CONCATENATED MODULE: ./src/components/entity/draw/cards/draw-cards/index.jsx










var DrawCards = function() {
    var t = (0,esm/* useTranslation */.$G)("draw").t;
    var user = (0,es/* useSelector */.v9)(function(param) {
        var user = param.user;
        return user;
    }).user;
    var pointsData = (0,react.useMemo)(function() {
        return (0,locus/* getLocusWithRegistrationBonus */.S)(user.balance);
    }, [
        user.balance
    ]);
    var cards = (0,react.useMemo)(function() {
        return [
            {
                Icon: icons/* MoneyGoldIcon */.$N,
                count: (pointsData === null || pointsData === void 0 ? void 0 : pointsData.goldPoints) || 0,
                label: "Gold Locus",
                btn: {
                    text: t("draw::cards::topUp"),
                    link: (0,router/* binder */._W)(router/* path.PUBLICATION_LOCUS */.ET.PUBLICATION_LOCUS, {
                        locus: definition/* LOCUS_TYPES.GOLD */.YK.GOLD
                    })
                },
                link: {
                    href: router/* path.CABINET_PROMOCODE */.ET.CABINET_PROMOCODE,
                    text: t("draw::cards::enterPromocode")
                }
            },
            {
                Icon: icons/* MoneySilverIcon */.qw,
                count: (pointsData === null || pointsData === void 0 ? void 0 : pointsData.silverPoints) || 0,
                label: "Silver Locus",
                btn: {
                    text: t("draw::cards::topUp"),
                    link: (0,router/* binder */._W)(router/* path.PUBLICATION_LOCUS */.ET.PUBLICATION_LOCUS, {
                        locus: definition/* LOCUS_TYPES.SILVER */.YK.SILVER
                    })
                },
                link: {
                    href: "/draw/apartments/convertation",
                    text: t("draw::cards::convert"),
                    info: t("draw::cards::convertInfo")
                }
            }, 
        ];
    }, [
        t,
        user,
        pointsData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (draw_cards_styles_module_default()).cardsRow,
        children: cards.map(function(card) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (draw_cards_styles_module_default()).infoCardWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(with_button, {
                    card: card
                })
            }, card.label);
        })
    });
};
/* harmony default export */ var draw_cards = (DrawCards);


/***/ }),

/***/ 70631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25155);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61257);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20068);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _constants_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32763);
/* harmony import */ var _constants_definition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13412);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80804);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);









var InfoCardWithLocuses = function(param) {
    var gold = param.gold, silver = param.silver;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)([
        "common",
        "draw"
    ]).t;
    var data = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return [
            {
                label: t("locus::gold"),
                value: gold || 0,
                href: _constants_router__WEBPACK_IMPORTED_MODULE_6__/* .path.CABINET_PROMOCODE */ .ET.CABINET_PROMOCODE,
                linkText: t("draw::cards::enterPromocode"),
                icon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .MoneyGoldIcon */ .$N,
                isPopover: false
            },
            {
                label: t("locus::silver"),
                value: silver || 0,
                href: _constants_router__WEBPACK_IMPORTED_MODULE_6__/* .path.DRAW_APARTMENTS_CONVERTATION */ .ET.DRAW_APARTMENTS_CONVERTATION,
                linkText: t("draw::cards::convert"),
                icon: _icons__WEBPACK_IMPORTED_MODULE_4__/* .MoneySilverIcon */ .qw,
                isPopover: true
            }, 
        ];
    }, [
        t,
        gold,
        silver
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardRow),
                children: data.map(function(param) {
                    var label = param.label, value = param.value, href = param.href, linkText = param.linkText, Icon = param.icon, isPopover = param.isPopover;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardColumn),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardLabel),
                                children: label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardCountRow),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardIcon),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardCount),
                                        children: value
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: href,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    rel: "nofollow",
                                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().linkText),
                                    children: [
                                        linkText,
                                        isPopover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* .PopoverIcon */ .f8, {})
                                        })
                                    ]
                                })
                            })
                        ]
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: (0,_constants_router__WEBPACK_IMPORTED_MODULE_6__/* .binder */ ._W)(_constants_router__WEBPACK_IMPORTED_MODULE_6__/* .path.PUBLICATION_LOCUS */ .ET.PUBLICATION_LOCUS, {
                    locus: _constants_definition__WEBPACK_IMPORTED_MODULE_7__/* .LOCUS_TYPES.GOLD */ .YK.GOLD
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    rel: "nofollow",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().cardButtonWrapper),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        text: t("draw::cards::topUp"),
                        type: _components_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .BUTTON_TYPES.BLUE */ .Dx.BLUE
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_5__.memo)(InfoCardWithLocuses));


/***/ }),

/***/ 95657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/entity/draw/cards/draw-cards/index.jsx + 3 modules
var draw_cards = __webpack_require__(80423);
// EXTERNAL MODULE: ./src/components/entity/draw/cards-mobile/styles.module.css
var styles_module = __webpack_require__(72955);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(25155);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/components/ui/button/index.jsx
var ui_button = __webpack_require__(61257);
// EXTERNAL MODULE: ./src/components/ui/button-tabs/index.jsx
var button_tabs = __webpack_require__(63688);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/entity/draw/cards/info-cards/with-two-buttons/index.jsx







var InfoCardWithTwoButtons = function(param) {
    var _card = param.card, label = _card.label, count = _card.count, buttons = _card.buttons;
    var router = useRouter();
    var ref = useState(buttons[0].value), active = ref[0], setActive = ref[1];
    var isCurrent = useCallback(function(current) {
        return active === current.value;
    }, [
        buttons
    ]);
    var changeTab = useCallback(function(item) {
        router.push(item === null || item === void 0 ? void 0 : item.link);
        setActive(item.value);
    }, [
        setActive
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.cardContainer,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.cardText,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cardCount,
                        children: count
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cardLabel,
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cardButtons,
                children: /*#__PURE__*/ _jsx(ButtonTabs, {
                    buttons: buttons,
                    onClick: changeTab,
                    isCurrent: isCurrent
                })
            })
        ]
    });
};
/* harmony default export */ var with_two_buttons = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(InfoCardWithTwoButtons))));

// EXTERNAL MODULE: ./src/components/entity/draw/cards/info-cards/with-locuses/index.jsx
var with_locuses = __webpack_require__(70631);
// EXTERNAL MODULE: ./src/components/entity/draw/sidebar/infocenter/video/index.jsx + 2 modules
var video = __webpack_require__(8171);
// EXTERNAL MODULE: ./src/lib/utils/locus.js
var locus = __webpack_require__(30616);
;// CONCATENATED MODULE: ./src/components/entity/draw/cards-mobile/index.jsx











var DrawCardsMobile = function() {
    var t = (0,esm/* useTranslation */.$G)("draw").t;
    var user = (0,es/* useSelector */.v9)(function(param) {
        var user = param.user;
        return user;
    }).user;
    var rafflesVideos = (0,es/* useSelector */.v9)(function(param) {
        var draw = param.draw;
        return draw;
    }).rafflesVideos;
    var pointsData = (0,react.useMemo)(function() {
        return (0,locus/* getLocusWithRegistrationBonus */.S)(user.balance);
    }, [
        user.balance
    ]);
    var data = {
        gold: (pointsData === null || pointsData === void 0 ? void 0 : pointsData.goldPoints) || 0,
        silver: (pointsData === null || pointsData === void 0 ? void 0 : pointsData.silverPoints) || 0
    };
    var card = (0,react.useMemo)(function() {
        return {
            label: t("draw::cards::tasks", {
                count: Number(user === null || user === void 0 ? void 0 : user.tasksUncompleted) || 0
            }),
            count: (user === null || user === void 0 ? void 0 : user.tasksUncompleted) || 0,
            buttons: [
                {
                    text: t("draw::cards::earnLocus"),
                    link: "/draw/tasks",
                    size: ui_button/* BUTTON_SIZES.DEFAULT */.Gt.DEFAULT,
                    type: ui_button/* BUTTON_TYPES.BLUE */.Dx.BLUE,
                    value: "tasks"
                },
                {
                    text: t("draw::cards::learnMore"),
                    link: "/blog",
                    size: ui_button/* BUTTON_SIZES.DEFAULT */.Gt.DEFAULT,
                    type: ui_button/* BUTTON_TYPES.YELLOW */.Dx.YELLOW,
                    value: "blog"
                }, 
            ]
        };
    }, [
        t,
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).cardsColumn,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(with_locuses/* default */.Z, (0,_object_spread/* default */.Z)({}, data)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, {
                videos: rafflesVideos
            })
        ]
    });
};
/* harmony default export */ var cards_mobile = (DrawCardsMobile);

// EXTERNAL MODULE: ./src/components/entity/draw/layout/layout-with-sidebar/index.jsx + 6 modules
var layout_with_sidebar = __webpack_require__(91783);
// EXTERNAL MODULE: ./src/components/entity/draw/layout/styles.module.css
var layout_styles_module = __webpack_require__(65949);
var layout_styles_module_default = /*#__PURE__*/__webpack_require__.n(layout_styles_module);
// EXTERNAL MODULE: ./src/components/ui/paragraph/index.jsx
var ui_paragraph = __webpack_require__(83904);
// EXTERNAL MODULE: ./src/components/entity/draw/links/index.jsx + 1 modules
var links = __webpack_require__(49095);
;// CONCATENATED MODULE: ./src/components/entity/draw/layout/index.jsx









var DrawLayout = function(param) {
    var children = param.children, openInstruction = param.openInstruction, openCharity = param.openCharity;
    var t = (0,esm/* useTranslation */.$G)("draw").t;
    var paragraph = {
        title: t("draw::paragraph::title"),
        text: t("draw::paragraph::text")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_with_sidebar/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (layout_styles_module_default()).drawCardsWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(draw_cards/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_mobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (layout_styles_module_default()).drawParagraph,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_paragraph/* default */.Z, (0,_object_spread/* default */.Z)({}, paragraph))
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (layout_styles_module_default()).drawLinks,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links/* default */.Z, {
                    openInstruction: openInstruction,
                    openCharity: openCharity
                })
            })
        ]
    });
};
/* harmony default export */ var layout = (DrawLayout);


/***/ }),

/***/ 5512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ui/categories/item/styles.module.css
var styles_module = __webpack_require__(93298);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/ui/categories/item/index.jsx



var CategoriesItem = function(param) {
    var isCurrent = param.isCurrent, label = param.label, onClick = param.onClick, length = param.length, isFirst = param.isFirst;
    // Calculate dynamic classes based on props
    var getItemClasses = function() {
        var classes = [
            (styles_module_default()).categoriesItemStyle
        ];
        if (isCurrent) {
            classes.push((styles_module_default()).isCurrent);
            // Handle first child border radius logic
            if (isFirst && length < 5) {
                classes.push((styles_module_default()).firstChildShortList);
            }
        }
        // Handle length-based styling for bottom border
        if (length <= 4) {
            classes.push((styles_module_default()).lengthLte4);
        } else {
            classes.push((styles_module_default()).lengthGt4);
        }
        return classes.join(" ");
    };
    // Calculate dynamic inline styles for complex border logic
    var getItemStyle = function() {
        var itemStyle = {};
        // Handle complex bottom border logic for items in multi-row layouts
        if (length > 4) {
            var lastRowStart = 3 * Math.floor(length / 4) + 1 + Math.floor((length - 1) / 4);
        // This complex calculation matches the styled-components logic
        // We'll use CSS custom properties or additional logic if needed
        }
        return itemStyle;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getItemClasses(),
        onClick: onClick,
        style: getItemStyle(),
        children: label
    });
};
/* harmony default export */ var item = (/*#__PURE__*/(0,react.memo)(CategoriesItem));

// EXTERNAL MODULE: ./src/components/ui/categories/styles.module.css
var categories_styles_module = __webpack_require__(38473);
var categories_styles_module_default = /*#__PURE__*/__webpack_require__.n(categories_styles_module);
;// CONCATENATED MODULE: ./src/components/ui/categories/index.jsx




var Categories = function(param) {
    var categories = param.categories, onItemClick = param.onItemClick, onIsCurrent = param.onIsCurrent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (categories_styles_module_default()).categoriesContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (categories_styles_module_default()).categoriesRow,
            children: categories === null || categories === void 0 ? void 0 : categories.map(function(param, index) {
                var label = param.label, data = param.data;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(item, {
                    label: label,
                    isCurrent: onIsCurrent(data) === true,
                    onClick: function() {
                        return onItemClick(data);
                    },
                    length: categories.length,
                    isFirst: index === 0
                }, index);
            })
        })
    });
};
/* harmony default export */ var categories = (/*#__PURE__*/(0,react.memo)(Categories));


/***/ }),

/***/ 30430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ image_with_percents; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ui/icons/index.jsx + 150 modules
var icons = __webpack_require__(20068);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/png/charityApartmentMock.png
/* harmony default export */ var charityApartmentMock = ({"src":"/_next/static/media/charityApartmentMock.8b80e19c.png","height":158,"width":135,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA5UlEQVR42h3JvUrDUBxA8T/4Aj6Ba57ARRAEJycFR8HZVQdxcPQBBHESHd0UBbW6xSJtHZQiaow1tiJVW9s0/Uhz2+Te04/hBweOJP2+BVjRECM6tiKlxi0aVFypqc7eofpN3ShgTGutJA6a/M2v0JMZHmeXODi75N9vACBlO21sEZOdmjC3k2JcmTbXx+emUK4YcT487LlV7jaXyd5fUM3keVtY5KvwiVTDiNzaFg/7u7jOC54fkj65ol0sIvXhPF3f5mhjh5xT4t37JpV5Imh3EQOEQcBz/hW39EPNb1H3myRJwgB56bWIjEjOaQAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./src/components/ui/image-with-percents/styles.module.css
var styles_module = __webpack_require__(18980);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/ui/image-with-percents/index.jsx






var ImageWithPercents = function(param) {
    var image = param.image, cost = param.cost, raised = param.raised, _rate = param.rate, rate = _rate === void 0 ? 1 : _rate;
    var percent = (0,react.useMemo)(function() {
        return Math.floor(raised / rate / cost * 100);
    }, [
        raised,
        cost,
        rate
    ]);
    var topPercent = (0,react.useMemo)(function() {
        return 100 - percent;
    }, [
        percent
    ]);
    var percentCondition = (0,react.useMemo)(function() {
        return percent >= 100 ? 100 : percent;
    }, [
        percent
    ]);
    var imageContainerClass = "".concat((styles_module_default()).imageContainer, " ").concat(!image ? (styles_module_default()).noImage : "");
    var topClass = "".concat((styles_module_default()).top, " ").concat(topPercent !== 0 ? (styles_module_default()).hasOpacity : "", " ").concat(percentCondition === 100 ? (styles_module_default()).fullPercent : "");
    var percentClass = "".concat((styles_module_default()).percent, " ").concat(percentCondition === 100 ? (styles_module_default()).fullBg : (styles_module_default()).normalBg);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: imageContainerClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: (styles_module_default()).imageWrapper,
                layout: image ? "fill" : "fixed",
                src: image || charityApartmentMock,
                unoptimized: true,
                alt: "apartment"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: topClass,
                style: {
                    height: topPercent ? "".concat(topPercent, "%") : "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).bottom,
                style: {
                    height: percentCondition ? "".concat(percentCondition, "%") : "0%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: percentClass,
                    children: [
                        percentCondition,
                        "%"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).ruler,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).greyWrapper,
                        style: {
                            height: topPercent ? "".concat(topPercent, "%") : "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RulerGreyIcon */.v2, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).greenWrapper,
                        style: {
                            height: percentCondition ? "".concat(percentCondition, "%") : "0%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RulerGreenIcon */.VK, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var image_with_percents = (/*#__PURE__*/(0,react.memo)(ImageWithPercents));


/***/ }),

/***/ 79077:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemColumn":"styles_itemColumn__3pR1A","itemTop":"styles_itemTop__VQyx3","itemBottom":"styles_itemBottom__SOUHR","isFullHeight":"styles_isFullHeight__hwXJW"};

/***/ }),

/***/ 72955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsColumn":"styles_cardsColumn__aV6Di"};

/***/ }),

/***/ 92744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsRow":"styles_cardsRow__n2awD","infoCardWrapper":"styles_infoCardWrapper__AoQEK"};

/***/ }),

/***/ 54587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWithBtnColumn":"styles_cardWithBtnColumn__oQvoM","cardWithBtnButtons":"styles_cardWithBtnButtons__eP5PS","buttonContainer":"styles_buttonContainer__TZpVu","linkText":"styles_linkText__kUw2g"};

/***/ }),

/***/ 80804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__8s5A5","cardRow":"styles_cardRow__uApJV","cardColumn":"styles_cardColumn__T_azr","cardLabel":"styles_cardLabel__6Uv5t","cardCountRow":"styles_cardCountRow___vMIj","cardIcon":"styles_cardIcon__SYf_h","cardCount":"styles_cardCount__tWZTL","linkText":"styles_linkText__VQp7t","cardButtonWrapper":"styles_cardButtonWrapper__ziJrT"};

/***/ }),

/***/ 65949:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"drawBackground":"styles_drawBackground__zHF70","drawRow":"styles_drawRow__oLtMU","isCharity":"styles_isCharity__Eosv9","drawMainColumn":"styles_drawMainColumn____C2r","drawSidebarStyle":"styles_drawSidebarStyle__lOBvH","drawParagraph":"styles_drawParagraph__wrenp","tabWrapper":"styles_tabWrapper__rAmtt","breadcrumbsWrapper":"styles_breadcrumbsWrapper__d8p7y","drawLinks":"styles_drawLinks__B35r0","drawCardsWrapper":"styles_drawCardsWrapper__ku8iL"};

/***/ }),

/***/ 93298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesItemStyle":"styles_categoriesItemStyle__vm_Mw","isCurrent":"styles_isCurrent__1DfMM","isFirst":"styles_isFirst__8VIY_","lastRow":"styles_lastRow__JRiLn","lengthLte4":"styles_lengthLte4__DeMN4"};

/***/ }),

/***/ 38473:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"styles_categoriesContainer__Y3NLm","categoriesRow":"styles_categoriesRow__gHNr8"};

/***/ }),

/***/ 18980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__RxK_t","noImage":"styles_noImage__L4_4J","top":"styles_top__vlXS1","hasOpacity":"styles_hasOpacity__PIWW2","fullPercent":"styles_fullPercent__H_Oen","bottom":"styles_bottom__lKYfx","percent":"styles_percent__F_JL6","fullBg":"styles_fullBg__5GIZc","normalBg":"styles_normalBg__siVff","ruler":"styles_ruler__c40b6","greyWrapper":"styles_greyWrapper__gnfNy","greenWrapper":"styles_greenWrapper__uTOIq","imageWrapper":"styles_imageWrapper__QTiG8"};

/***/ }),

/***/ 77470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"styles_popoverContainer__nc6vO","iconContainer":"styles_iconContainer__IUeP_","popoverPopup":"styles_popoverPopup__LagRl","popoverText":"styles_popoverText__svOQL"};

/***/ }),

/***/ 6051:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popoverRow":"styles_popoverRow___st0_"};

/***/ })

}]);